var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmCameroon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H40.0031V45H60V0Z",
    fill: "#007A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0029 0H19.9967V45H40.0029V0Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9971 0H0.000196457V45H19.9971V0Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 17.1667L31.667 22.2333L29.1337 23.1L30.0003 17.1667Z",
    fill: "#FCD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmCameroon);
export default __webpack_public_path__ + "static/media/cm Cameroon.ee079605070ef2c29ced74ad1b926485.svg";
export { ForwardRef as ReactComponent };